var _path, _rect, _path2, _ellipse, _rect2, _rect3, _rect4, _rect5, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeGarage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 251,
    viewBox: "0 0 201 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1052 220.005C40.6744 219.366 41.4896 219 42.3455 219H157C158.657 219 160 220.343 160 222V248C160 249.657 158.657 251 157 251H19.1892C16.5993 251 15.2264 247.939 16.9489 246.005L40.1052 220.005Z",
    fill: "#D9D9D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 195,
    width: 49,
    height: 24,
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 87.5218C0 85.9809 0.885047 84.5771 2.27531 83.9127L107.275 33.7357C109.93 32.467 113 34.4024 113 37.3448V191C113 193.209 111.209 195 109 195H4C1.79086 195 0 193.209 0 191V87.5218Z",
    fill: "#BCBCBC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.5,
    cy: 97,
    rx: 20.5,
    ry: 78,
    fill: "#34495E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    width: 70,
    height: 195,
    rx: 3,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 136,
    width: 4,
    height: 40,
    rx: 2,
    fill: "black",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 131,
    width: 4,
    height: 45,
    rx: 2,
    fill: "black",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 125,
    width: 4,
    height: 51,
    rx: 2,
    fill: "black",
    fillOpacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.045,
    cy: 61.0891,
    rx: 2.17249,
    ry: 26,
    transform: "rotate(-7.49638 191.045 61.0891)",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeGarage);
export default __webpack_public_path__ + "static/media/code-garage.986a85c0575a4e1e8d44b9619f3bacfc.svg";
export { ForwardRef as ReactComponent };